import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment.dev";
import { BaseService } from "../../@core/services/base.service";
import { IDocumentType, ITag, ITagType } from "../models/settings.model";


export enum DocumentTypeFilter {
    GENERAL = "GENERAL", // the ones which are not related to form
    FORM_RELATED = "FORM_RELATED"// only the ones which contains a form
}

@Injectable({ providedIn: 'root' })
export class DocumentTypeService extends BaseService {

    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    apiUrl = environment.apiUrl + '/document-type';

    getDocTypes(types: DocumentTypeFilter[] = [DocumentTypeFilter.GENERAL]) {
        return this.post<IDocumentType[]>(this.apiUrl + '/doc-types', { types })
    }

    getLinkedTagTypes(docTypeId: IDocumentType['_id']) {
        return this.get<ITagType[]>(this.apiUrl, { docTypeId })
    }

    addUpdateDocType(docType: Partial<IDocumentType>) {
        return this.put<IDocumentType>(this.apiUrl, docType)
    }

    deleteDocType(docTypeId: string) {
        return this.delete<IDocumentType | null>(this.apiUrl + '/' + docTypeId)
    }

}